import React from 'lib/react';
import { EXPORT_DATA_ROUTE, ANALYTICS_DASHBOARD_ROUTE } from 'constants/RouteConstants';
import { Switch, Route } from 'lib/router';
import ReportFiltersRow from './components/exportData/exportDataFilters/ReportFiltersRow.component';
import ExportData from './components/exportData';
import Analytics from './components/analytics';

function AnalyticsDashboard() {
  return (
    <>
      <ReportFiltersRow />
      <Switch>
        <Route exact path={ANALYTICS_DASHBOARD_ROUTE} component={Analytics} />
        <Route exact path={EXPORT_DATA_ROUTE} component={ExportData} />
      </Switch>
    </>
  );
}

export default AnalyticsDashboard;
